import { ADD_ENTITIES } from "../actions/actions";
import { mergeEntitiesWithState, product, productVariant } from "../helpers/schema";
import {
    FETCH_PRODUCTS_REQUEST,
    FETCH_PRODUCTS_SUCCESS,
    INVALIDATE_PRODUCTS
} from "../actions/product.actions";

const schema = product;

export function products(
  state = {
      isFetching: false,
      didInvalidate: false,
      fetched: false,
      all: {}
  },
  action
) {
    switch (action.type) {
        case INVALIDATE_PRODUCTS:
            state.all = {};
            return Object.assign({}, state, {
                ...state,
                didInvalidate: true
            })
        case ADD_ENTITIES:
            let data = action.payload.product;
            if (!data) return state

            return {
                ...state,
                all: mergeEntitiesWithState(data, state.all, schema)
            };
        case FETCH_PRODUCTS_REQUEST:
            return Object.assign({}, state, {
                ...state,
                isFetching: true,
                didInvalidate: false
            })
        case FETCH_PRODUCTS_SUCCESS:
            return Object.assign({}, state, {
                ...state,
                fetched: true,
                isFetching: false,
                didInvalidate: false,
                lastUpdated: action.receivedAt
            })
        default:
            return state
    }
}